/** Route patterns for vendor invoice flows (no lazy imports; safe to import from pages). */
export const VENDOR_INVOICE_LIST_PATH = '/dashboard/vendor/vendor-invoice' as const

export const VENDOR_INVOICE_REVIEW_PATH = '/dashboard/vendor/vendor-invoice-review/:id' as const

export const VENDOR_INVOICE_SKU_MATCH_PATH =
  '/dashboard/vendor/vendor-invoice-review/:id/sku-match' as const
